import { ConfigType } from "dayjs";
import { formatInTimeZone } from "@/components/timezone";
import { useGetTenantSettings } from "./useGetTenantSettings";

/**
 * Exposes the tenant's configured timezone for displaying exam term dates/deadlines.
 * Reuses the cached tenant settings query, so it does not trigger extra requests.
 */
export const useTenantTimezone = () => {
  const { data } = useGetTenantSettings(true);

  const iana = data?.defaultTimeZoneIana ?? null;
  const label = data?.timezoneLabel ?? null;

  const format = (date: ConfigType, fmt: string) => formatInTimeZone(date, iana, fmt);

  return { iana, label, format };
};
